import { Alert } from '@/shared/ui/Alert';

/**
 * Como o laudo de emissao usa o modelo do tipo "Laudo de emissao" (P-MIN-3). Ver
 * docs/ADR/0052-modelo-do-laudo-de-emissao.md.
 *
 * No OnPoint o laudo sai do modelo da seguradora, com o logotipo e a razao social dela.
 * Aqui o modelo e carga da empresa por esta tela, e a regra de qual vale precisa estar
 * escrita onde ele e criado: quem publica um segundo modelo sem saber troca o laudo de
 * todas as apolices.
 */
export function AvisoDoLaudo() {
  return (
    <Alert tone="info" title="Como o laudo de emissao usa este modelo">
      O laudo de cada apolice e montado, a cada download, pelo modelo deste tipo em Word
      que estiver ativo e com versao publicada. Com mais de um, vale o publicado por
      ultimo. Sem nenhum, o laudo sai do modelo neutro do sistema. Modelo em texto nao
      monta o laudo. Os dados sao sempre os gravados na emissao: o modelo so muda o
      leiaute, e o campo sem fonte sai vazio, com a pendencia na tabela de pendencias.
    </Alert>
  );
}
